import { ThermoboxReportCustomModalCell } from './components/thermobox-report-custom-modal-cell';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const THERMOBOX_REPORT_FORM_NAME = 'thermobox-report-form';
export const THERMOBOX_REPORT_DOCUMENTS_FORM_NAME = 'thermobox-report-documents';

export const THERMOBOX_REPORT_TABLE_COLUMNS_NAMES = [
	{ id: 'title' },
	{ id: 'value', customComponent: ThermoboxReportCustomModalCell },
];

export const DATE_FORMAT = 'DD.MM.YYYY';

export const THERMOBOX_REPORT_TABLE_ROWS_NAMES = {
	date: 'Дата проведения',
	thermobox: 'Термоконтейнер',
	mode: 'Температурный режим',
	repeats: 'Кол-во повторностей',
	holdTime: 'Время сохранения Т-режима',
	outerMode: 'Внешняя средняя температура',
	inner: 'Внутренние геометрические размеры комплекта',
	innerVolume: 'Внутренний объем комплекта',
	palletWeight: 'Масса комплекта на паллете',
	author: 'Автор',
	icepacks: 'Хладоэлемент',
};

export const REQUIRED_FIELDS = [
	'date',
	'number',
	'thermobox_id',
	'mode_id',
	'repeats',
	'outer_mode',
	'inner_length',
	'inner_width',
	'inner_height',
	'pallet_weight',
	'icepacks',
];

export const FIELDS_FOR_VALIDATE = [
	'date',
	'number',
	'thermobox_id',
	'mode_id',
	'repeats',
	'hold_hours',
	'hold_minutes',
	'outer_mode',
	'inner_length',
	'inner_width',
	'inner_height',
	'pallet_weight',
];

export const ICEPACKS_REQUIRED_FIELDS = ['icepack_filled_id', 'count'];
